module.exports = __webpack_public_path__ + "05_short_gray.3a0bd2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/05_short_gray.png
// module id = qH6y
// module chunks = 0